var VCA = VCA || {};

VCA.JoinOurNewsletter = (function ($) {

    var ui = {};

    function cacheUI() {
        ui.$submitBtn = $('.newsletter-signup-btn');
        ui.$firstName = $('.newsletter-signup-firstname-field');
        ui.$lastName = $('.newsletter-signup-lastname-field');
        ui.$newsletterForm = $('.newsletter-signup');
    }

    function validateFirstLastName() {
        let firstName = ui.$firstName.val();
        let lastName = ui.$lastName.val();

        let isFirstNameValid = /^[a-z ,.'-]+$/i.test(firstName);
        let isLastNameValid = /^[a-z ,.'-]+$/i.test(lastName);


        if (!isFirstNameValid || firstName.trim() == '') {
            ui.$firstName.addClass('input-validation-error');
        } 
        if (!isLastNameValid || lastName.trim() == '') {
            ui.$lastName.addClass('input-validation-error');
        }
        if (isFirstNameValid || firstName.trim() !== '') {
            ui.$firstName.removeClass('input-validation-error');
        }
        if (isLastNameValid || lastName.trim() !== '') {
            ui.$lastName.removeClass('input-validation-error');
        }

        if (isFirstNameValid && isLastNameValid && firstName.trim() !== '' && lastName.trim() !== '') {
            return true;
        } else {
            return false;
        }
    }

    function bindSubmitClick() {
        ui.$submitBtn.on('click', function (e) {
            e.preventDefault();
            let inputFieldsAreValid = validateFirstLastName();

            if (inputFieldsAreValid) {
                ui.$newsletterForm.submit();
            }
        });
    }

    function init() {
        if ($('.js-newsletter-form').length <= 0) {
            return;
        }

        cacheUI();
        bindSubmitClick();
    }

    return {
       init: init
    };

})(jQuery);

$(function () {
    VCA.JoinOurNewsletter.init();
});